import axios from "axios";
import { createContext, useContext, useState, useCallback } from "react";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return e?.message || "Error";
};

export const fetchProducts = async (world) => {
  try {
    const res = await http.get("/products", { params: world ? { world } : {} });
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
};

const BagCtx = createContext({ count: 0, add: () => {} });

export const BagProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("anvocra_bag")) || []; } catch { return []; }
  });
  const add = useCallback((item, msg) => {
    setItems((prev) => {
      const next = [...prev, item];
      localStorage.setItem("anvocra_bag", JSON.stringify(next));
      return next;
    });
    toast(msg);
  }, []);
  return <BagCtx.Provider value={{ count: items.length, add }}>{children}</BagCtx.Provider>;
};

export const useBag = () => useContext(BagCtx);

export const worldFromSlug = (slug) => (slug === "old-money" ? "oldmoney" : "street");
export const slugFromWorld = (w) => (w === "oldmoney" ? "old-money" : "streetwear");
